module.exports = __webpack_public_path__ + "img/avatar5.f1e2c382.png";